<template>
  <section
    :class="[
      'paragraph',
      { 'paragraph--light': isFestivalYear },
      { 'paragraph--information': template === 'information' },
    ]"
  >
    <!-- <div class="paragraph__title" v-if="!isNested && category !== 'festival'">
      <img
        :src="require(`@/assets/images/article/${category}-title@2x.png`)"
        :srcset="
          require(`@/assets/images/article/${category}-title.png`) +
            ' 1x, ' +
            require(`@/assets/images/article/${category}-title@2x.png`) +
            ' 2x'
        "
        :alt="titleLabel"
        :title="titleLabel"
        class="paragraph__title__image"
      />
    </div> -->
    <!-- 當是旅遊段落時 -->

    <div v-if="category === 'theme'">
      <div
        v-for="(paragraph, index) in paragraphs"
        :key="index"
        class="paragraph__content"
      >
        <!-- type 1 是自定義的次段落，type 2-4 是後台內文引用，業主決定暫且不顯示 -->
        <h3 v-if="paragraph.reference.title && paragraph.type === 1">
          {{ paragraph.reference.title }}
        </h3>
        <p v-if="paragraph.reference.content && paragraph.type === 1"
          >{{ paragraph.reference.content }}
        </p>
        <!-- 文章次段落 -->
        <ArticleSubParagraphs
          :parentIndex="index"
          :subParagraphs="
            getSubParagraphMedia(category, index, isNested, paragraph)
          "
          v-if="
            paragraph.type === 1 && paragraph.reference.sub_paragraphs.length
          "
        />
      </div>
    </div>
    <div v-else>
      <div
        v-for="(paragraph, index) in paragraphs"
        :key="index"
        class="paragraph__content"
      >
        <h3 v-if="paragraph.title">{{ paragraph.title }}</h3>
        <p v-if="paragraph.content">{{ paragraph.content }}</p>
        <ArticleSubParagraphs
          :parentIndex="index"
          :subParagraphs="
            getSubParagraphMedia(category, index, isNested, paragraph)
          "
          v-if="paragraph.sub_paragraphs && paragraph.sub_paragraphs.length"
        />
      </div>
      <slot name="checkOutArtwork"></slot>
    </div>

    <slot></slot>
  </section>
</template>

<script>
import { getArticleString } from '@/config/articleString';

import ArticleSubParagraphs from '@/components/article/ArticleSubParagraphs';

export default {
  name: 'ArticleParagraphs',
  props: {
    paragraphs: {
      type: Array,
      default: () => [],
    },
    category: {
      type: String,
      default: '',
    },
    isNested: {
      type: Boolean,
      default: false,
    },
    template: {
      type: String,
      default: 'information',
    },
  },
  data() {
    return {};
  },
  computed: {
    titleLabel() {
      return getArticleString(this.category, 'titleLabel');
    },
    isFestivalYear() {
      return this.$route.meta.isRenderingFestivalTheme;
    },
  },
  methods: {
    getSubParagraphMedia(module, index, isNested, paragraph) {
      return this.$store.getters.getSubParagraphMedia(
        module,
        index,
        isNested,
        paragraph
      );
    },
  },
  components: {
    ArticleSubParagraphs,
  },
};
</script>

<style lang="scss" scoped>
.paragraph {
  margin-bottom: 30px;

  @include for-desktop {
    display: inline-block;
    vertical-align: top;
    text-align: center;
  }

  &__title {
    text-align: center;
    margin-bottom: 5px;

    @include for-tablet {
      margin-bottom: 20px;
    }

    &__image {
      max-width: 100%;
      height: 140px;
    }
  }
  &__content {
    text-align: justify;
    text-align-last: left;

    > h3,
    > p {
      margin: 0;
      color: $color-light-paragraph;
    }

    > h3 {
      font-size: 1.125rem;
      line-height: 1.5;
      letter-spacing: 1px;
      margin-bottom: 10px;
    }

    > p {
      font-size: 1rem;
      line-height: 1.5;
      margin-bottom: 25px;
      white-space: pre-line;
      text-align: justify;
      text-align-last: left;
    }
  }

  &--light {
    @include for-desktop {
      text-align: left;
    }
    /deep/ .paragraph {
      &__sub-paragraphs {
        max-width: 620px;
        margin: auto;

        @include for-tablet {
          flex-flow: wrap;
          padding-left: 0;
          padding-right: 0;
        }

        .card-with-words {
          &__video {
            @include for-tablet {
              height: 200px;
            }
          }

          &__photo > img {
            @include for-tablet {
              height: 200px;
            }
          }

          &__description {
            /* 比全域的段落文字權重更高 */
            padding: 5px 0 !important;
            font-size: 0.75rem !important;

            @include truncate-multiple-lines(2, 100%);
          }
        }
      }

      &__cards--one-card {
        max-width: 270px;
      }

      &__cards {
        @include for-tablet {
          max-width: 288px;
          margin-top: 10px;
          margin-bottom: 10px;
        }
      }
    }

    /deep/ .paragraph__cards + .paragraph__cards {
      @include for-tablet {
        margin-left: 0;
      }
    }

    /deep/.paragraph__cards {
      &:nth-child(2n) {
        @include for-tablet {
          margin-left: 19px;
        }
      }
    }
  }

  &--information {
    width: 100%;
  }
}
</style>
